import { Component, Input } from '@angular/core';
import { Inventory } from 'src/app/interfaces/inventory';

const defaultItem: Inventory = {
  id: 0,
  name: '',
  active: false,
};

@Component({
  selector: 'app-custom-dropdown-sede-item',
  templateUrl: './custom-dropdown-sede-item.component.html',
  styleUrls: ['./custom-dropdown-sede-item.component.scss'],
})
export class CustomDropdownSedeItemComponent {
  @Input() logo: string = '';
  @Input() business: string = '';
  @Input() selectedLocation: Inventory = defaultItem;
  @Input({ required: true }) location: Inventory = defaultItem;
}
